module.exports = __webpack_public_path__ + "img/1696320477674-WhatsApp Image 2023-10-03 at 14.35.10 1.jpeg.72502e8f.webp";